<template>
  <SelectDepartmentDialog
    :dialogTitle="dialogTitle"
    :centerDialogVisible="visible"
    @updateVisible="updateVisible"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
    :popupWidth="'600px'"
    :appendToBody="false"
  >
    <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
    <div class="selectDepartmentTree">
      <el-tree
        class="filter-tree"
        :data="data"
        :props="defaultProps"
        default-expand-all
        :filter-node-method="filterNode"
        ref="tree"
        @node-click="handleNodeClick"
        @check="handleCheck"
        node-key="orgId"
        highlight-current
        :expand-on-click-node="false"
      >
      </el-tree>
    </div>
  </SelectDepartmentDialog>
</template>

<script>
import SelectDepartmentDialog from "../../../../components/common/epecDialog";
import Api from "../../api/authority/index";
export default {
  name: "selectDepartmentDialog",
  components: {
    SelectDepartmentDialog,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      dialogTitle: "组织机构",
      filterText: "",
      defaultProps: {
        children: "childList",
        label: "shortFullName",
      },
      data: [],
      currentNode: [],
    };
  },
  computed: {},
  created() {
    this.getDepartmentTree();
  },
  methods: {
    updateVisible() {},
    resetPopupData() {
      this.$emit("close");
    },
    submitPopupData() {
      this.$emit("getNode", this.currentNode);
      this.$emit("close");
    },
    getDepartmentTree() {
      Api.queryDepartmentTree().then((res) => {
        this.data.push(res.data);
      });
    },
    handleNodeClick(data) {
      this.currentNode = data;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.shortFullName.indexOf(value) !== -1;
    },
    handleCheck(a, b) {
      if (b.checkedKeys.length > 0) {
        this.$refs.tree.setCheckedKeys([a.companyId]);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.selectDepartmentTree {
  min-height: 200px;
}

.el-tree-node.is-current > .el-tree-node__content {
  background-color: #409eff !important;
}
</style>
